import React from 'react'
import { Customer } from '../models/shared/Customer';
import { useText } from '../context/TextContext';

interface Props {
    customer?: Customer | null;
    noIdentifier?: boolean;
}

export default function CustomerContact({ customer, noIdentifier }: Props) {
    const text = useText();
    return (<>
        {!noIdentifier &&
            <div className='d-flex gap-2'>
                {customer?.type === 'company' ? <i className='bi bi-123' /> : <i>{text.personalNumberShort}</i>}
                {customer?.idNumber ?
                    <span>{customer.idNumber}</span> :
                    <span className='text-danger'>{text.missing}</span>
                }
            </div>
        }
        <div className='d-flex gap-2'>
            <i className='bi bi-envelope' />
            {customer?.email ? <a href={`mailto:${customer.email}`}>{customer.email}</a> : <span className='text-muted'>{text.missing}</span>}
        </div>
        <div className='d-flex gap-2'>
            <i className='bi bi-telephone' />
            {customer?.phone ? <a href={`tel:${customer.phone}`}>{customer.phone}</a> : <span className='text-muted'>{text.missing}</span>}
        </div>
    </>
    )
}
